
<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    bg: {
      type: String,
      default: "airbnbRed",
    },
    type: {
      type: String,
      default: "button",
    },
  },
  computed: {
    buttonBgColor() {
      if (this.disabled) {
        return ["bg-gray-700"];
      }
      return [`bg-${this.bg}`];
    },
  },
  methods: {
    clickHandler(e) {
      this.$emit("click", e);
    },
  },
};
</script>

<template>
  <button :class="buttonBgColor" class="p-3 font-semibold rounded text-white" :disabled="disabled" :type="type"
    @click="clickHandler">
    <slot />
  </button>
</template>
